// Serviço de captação de lead comercial (PDF §8, spec §13/§16).
//
// A criação do lead é desacoplada da interface: a Home só chama `enviarLead(...)`.
// Hoje o envio reusa o backend que já roda em produção
// (`web_rest.php?email_novoconsumidor=true`, o mesmo do form "Quero ser cliente").
// Quando existir o endpoint dedicado `POST /api/commercial/leads`, basta trocar
// a implementação de `postLead` — nenhum componente muda.

import axios from 'axios';
import { getUtm } from './utm';

const LEAD_ENDPOINT = 'https://siscredit.com.br/siscred/web_rest.php';

// Validações de formato (PDF §6 "Regras funcionais"; o backend deve revalidar).
export function validarLead({ nome, empresa, whatsapp, email, privacidade }) {
  const erros = {};
  if (!nome || nome.trim().length < 2) erros.nome = 'Informe seu nome.';
  if (!empresa || empresa.trim().length < 2) erros.empresa = 'Informe a empresa.';
  const foneDigitos = onlyDigits(whatsapp);
  if (foneDigitos.length < 10 || foneDigitos.length > 11) {
    erros.whatsapp = 'Informe um WhatsApp válido com DDD.';
  }
  // E-mail é opcional (PDF §6); só valida se preenchido.
  if (email && !isEmail(email)) erros.email = 'E-mail inválido.';
  if (!privacidade) erros.privacidade = 'É necessário aceitar a política de privacidade.';
  return { valido: Object.keys(erros).length === 0, erros };
}

// Monta o payload completo do lead (PDF §8). `origem` = cta_origin.
export function montarPayload(dados, origem) {
  return {
    name: dados.nome.trim().replace(/\s+/g, ' '),
    company: dados.empresa.trim().replace(/\s+/g, ' '),
    phone: onlyDigits(dados.whatsapp),
    email: (dados.email || '').trim(),
    interest: (dados.interesse || '').trim(),
    message: (dados.mensagem || '').trim(),
    cta_origin: origem || 'website_home',
    page_path: safePath(),
    consent_at: dados.privacidade ? new Date().toISOString() : null,
    created_at: new Date().toISOString(),
    ...getUtm(),
  };
}

// Envia o lead. Lança em caso de falha de rede/servidor.
export async function enviarLead(dados, origem) {
  return postLead(montarPayload(dados, origem));
}

// --- Implementação de transporte (isolada para troca futura) ---
async function postLead(payload) {
  // web_rest.php recebe os campos por querystring; o mapa abaixo casa com o
  // action `email_novoconsumidor` já usado pelo site.
  const params = new URLSearchParams({
    email_novoconsumidor: 'true',
    nome: payload.name,
    fantasia: payload.company,
    email: payload.email,
    celular: payload.phone,
    mensagem: montarMensagem(payload),
    origem: payload.cta_origin,
  });
  const { data } = await axios.post(`${LEAD_ENDPOINT}?${params.toString()}`);
  return data;
}

// Concentra interesse + origem + UTMs numa linha, já que o backend legado não
// tem colunas próprias para eles.
function montarMensagem(p) {
  const linhas = [];
  if (p.interest) linhas.push(`Interesse: ${p.interest}`);
  if (p.message) linhas.push(p.message);
  linhas.push(`Origem: ${p.cta_origin} (${p.page_path})`);
  const utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
    .filter((k) => p[k])
    .map((k) => `${k}=${p[k]}`);
  if (utm.length) linhas.push(`Campanha: ${utm.join(' ')}`);
  return linhas.join(' | ');
}

function onlyDigits(v) {
  return (v || '').replace(/\D/g, '');
}

function isEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
}

function safePath() {
  try {
    return window.location.pathname + window.location.hash;
  } catch (e) {
    return '';
  }
}
